'use client';

import { useRef } from 'react';

// Create a singleton state that can be shared across components
let isUpdatingFilters = false;

/**
 * Custom hook to manage the state of discovery filters updates
 * This allows components to coordinate when filters are being updated
 */
const useDiscoveryFiltersState = () => {
  // Create a ref to the shared state
  const filtersUpdatingRef = useRef(isUpdatingFilters);

  // Function to mark filters as updating
  const setFiltersUpdating = (updating: boolean) => {
    isUpdatingFilters = updating;
    filtersUpdatingRef.current = updating;
  };

  return {
    filtersUpdatingRef,
    setFiltersUpdating,
  };
};

export default useDiscoveryFiltersState;
